import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import App from './App.vue';
import './style.css';

// Routes
import Login from './views/Login.vue';
import Dashboard from './views/Dashboard.vue';
import Configs from './views/Configs.vue';
import Logs from './views/Logs.vue';

const routes = [
  { path: '/login', name: 'Login', component: Login },
  { 
    path: '/', 
    name: 'Dashboard', 
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  { 
    path: '/configs', 
    name: 'Configs', 
    component: Configs,
    meta: { requiresAuth: true }
  },
  { 
    path: '/logs', 
    name: 'Logs', 
    component: Logs,
    meta: { requiresAuth: true }
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation guard for auth
router.beforeEach((to, _from, next) => {
  const token = localStorage.getItem('auth_token');
  if (to.meta.requiresAuth && !token) {
    next('/login');
  } else if (to.path === '/login' && token) {
    next('/');
  } else {
    next();
  }
});

const app = createApp(App);
app.use(router);
app.mount('#app');
